export const initialState = () => ({
    products: [],
    productsBrands: [],
    productsBrandsSkeleton: {
		title: '',
        fileId: false
	},
    productsFiles: [],
    productsValidationErrors: false,
	productsValidationModal: false,
    productsSkeleton: {
		title: '',
		slug: '',
        description: '',
        categories: [],
        brandId: 0,
        published: false,
        files: []
    },
    categories: [
        {id:1, slug:'fire', label:'Fire'},
        {id:2, slug:'ppe', label:'PPE'}
    ],
})

export default initialState()